import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./index.module.less";
import { ConfigProvider, Pagination } from "antd";
import classNames from "classnames";
// 分页组件
const BPagination = (props) => {
    return (_jsx(ConfigProvider, { theme: {
            components: {
                Pagination: {
                    // 页码选中背景
                    itemActiveBg: "#577CF6",
                    // 页码大小
                    itemSize: 36,
                },
            },
        }, children: _jsx(Pagination, { showSizeChanger: false, ...props, rootClassName: classNames(styles.BPagination, props?.rootClassName) }) }));
};
BPagination.displayName = "BPagination";
export default BPagination;
